import PlayControl from './play-control.vue'
export default PlayControl
